<template>
    <div>
        <div class="mb-15">
            <el-button plain @click="$router.go(-1)">返回</el-button>
        </div>

        <div class="p-30 page f-14 flex jc-sb ai-fs">

            <div class="w-20p flex fd-c ai-fs">
                <div class="mb-10 f-18">答题卡</div>
                <div v-for="(g, i) in paper.mainQuestions" :key="i">

                    <div class="mb-10 f-12">
                        {{ g.mainQuestionName }}（共{{ g.subQuestions.length }}题，合计{{ g.totalScore }}分）
                    </div>
                    <div class="flex jc-fs mb-10">
                        <div @click="qChange(q)" v-for="(q, i) in g.subQuestions" :key="i" class="q-box"
                            :class="{ 'active': q.uKey == showQ }">{{ i + 1 }}</div>
                    </div>
                    <div class="line-h mb-10"></div>

                </div>
            </div>
            <div class="w-75p">
                <div v-for="(g, i) in qGroupList" :key="i">
                    <div v-for="(q, i) in g.subQuestions" :key="i">
                        <qItem class="pt-10 pb-10 pl-15 pr-15 bor-e9e9e9 mb-15" v-if="q.uKey == showQ" :question="q"
                            :index="i" type="preview"></qItem>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { paperEdit, questionList, paperInfo } from '@/api/index2';

import { watchArrayChange, cleanObject, generateUniqueString, uniqueArr, arrDelete } from '@/utils/utils';

import { encrypt, decrypt } from '@/api/common_encrypt';

import qItem from './components/qItem';
import dyTable from '@/components/common/dytable'
import paper from './route';


export default {
    name: 'paperPreview',
    components: {
        qItem,
        dyTable
    },
    data() {
        return {
            loading: false,

            showQ: "",

            tableLoading: false,
            addDialog: false,
            autoDialog: false,

            paper: {
                paperName: "",
                isTemplate: 0,
            },

            qGroupList: [],

        };
    },
    created() {

    },

    mounted() {
        this.pageInit();

    },
    activated() {

        this.pageInit();
    },

    computed: {

    },

    methods: {

        pageInit() {
            let param = ""
            if (this.$route.query.param) {
                param = JSON.parse(decrypt(this.$route.query.param))
            }
            this.paper = param.paper || {};
            this.getPaperDetail();
        },
        qChange(q) {
            this.showQ = q.uKey;
        },

        getPaperDetail() {

            this.loading = true;
            let param = {
                id: this.paper.id
            };

            paperInfo(param).then((res) => {
                if (res.result == 1) {
                    this.paper = res.data;
                    this.qGroupList = [...this.paper.mainQuestions]
                    this.qGroupList.forEach(g => {
                        g.uKey = generateUniqueString();
                        g.subQuestions.forEach(q => {
                            q.uKey = generateUniqueString();
                        })
                    })
                    this.showQ = this.qGroupList[0].subQuestions[0].uKey;
                    console.log('this.paper :>> ', this.paper);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
                this.loading = false;
            });

        },

        qPageNoChange(val) {
            this.qPageNo = val;
            this.qGetList();
        },

    }
};
</script>

<style lang='scss' scoped>
.q-box {
    border: 1px solid #e9e9e9;
    width: 20px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    color: #9e9e9e;
    font-size: 12px;
    margin-right: 5px;
}

.q-box.active {
    color: #1890ff;
    border-color: #1890ff;
}


.line-h {
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: #d8d8d8;
}
</style>
